import { Box, Grid, Skeleton, Typography } from '@mui/material';
import { useNavigate } from '@tanstack/react-router';
import { IProgressParts } from 'common-types';
import { useGetUserData } from 'hooks/use-get-user-data';
import theme from 'providers/theme/theme';
import { memo } from 'react';
import { useAnalytics } from 'services/analytics';
import { useStore } from 'store';
import { useShallow } from 'zustand/shallow';

import { emptyStateSx, itemSubtitleSx, itemTitleSx, recentHeadingSx } from './styles';

export const Recent = memo(() => {
  const { trackEvent } = useAnalytics();
  const navigate = useNavigate();
  const { isSuccess: isUserDataLoaded, userRecent } = useGetUserData();

  const { setPartView } = useStore(
    useShallow((state) => ({
      setPartView: state.setPartView,
    })),
  );

  const handleRecentClick = (item: IProgressParts): void => {
    trackEvent('recent_tap');

    const id = item?.id?.slice(0, item?.id?.indexOf('.'));
    const part = item?.id?.slice(item?.id?.indexOf('.') + 1);

    setPartView(+part);
    navigate({
      to: '/style-plan/$day',
      // @ts-expect-error strictNullChecks breaks TanStack Router inference
      params: { day: String(id) },
    });
  };

  if (!userRecent) {
    return null;
  }

  return (
    <Box
      borderRadius={4}
      minHeight={324}
      px={6}
      py={5}
      sx={{
        background: `linear-gradient(to bottom, ${theme.palette.custom.greyGradientFrom}, ${theme.palette.custom.greyGradientTo})`,
      }}
    >
      {isUserDataLoaded ? (
        <>
          <Typography sx={recentHeadingSx}>Recent</Typography>
          {userRecent?.length === 0 && (
            <Typography sx={emptyStateSx}>Visit your Style Plan to save recent pages here</Typography>
          )}
          <Box display="flex" flexDirection="column" gap={4}>
            {userRecent?.map((item) => (
              <Grid
                key={item?.topic}
                container
                flexWrap="nowrap"
                spacing={4}
                onClick={(): void => handleRecentClick(item)}
                sx={{ cursor: 'pointer' }}
              >
                <Grid size="auto">
                  <Box
                    component="img"
                    src={item?.screens[0]?.view[0]?.image?.url}
                    alt={item?.topic}
                    width={62}
                    height={62}
                    borderRadius={3}
                    sx={{ objectFit: 'cover' }}
                  />
                </Grid>
                <Grid size="grow" sx={{ minWidth: 0 }}>
                  <Typography sx={itemTitleSx}>{item?.topic}</Typography>
                  <Typography sx={itemSubtitleSx}>{item?.screens[0]?.title}</Typography>
                </Grid>
              </Grid>
            ))}
          </Box>
        </>
      ) : (
        <Skeleton variant="rounded" height={277} />
      )}
    </Box>
  );
});
